import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-2024"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M13.974 4.891a2.933 2.933 0 0 0-1.75-1.13C12.046 2.184 10.772 1.02 9.365.999 8.241.982 7.173 1.695 6.67 2.803a2.89 2.89 0 0 0-1.362.553 2.903 2.903 0 0 0-.879 1.082c-1.164-.155-1.99.454-2.352 1.181-.139-.035-.667-.155-1.207.131-.49.259-.873.79-.873 1.414-.001.709.491 1.289 1.08 1.51.73.274 1.378-.09 1.468-.143a2.7 2.7 0 0 0 1.717.639 2.667 2.667 0 0 0 1.473-.45c.177.086.507.221.932.31l-1.183 1.839a.232.232 0 0 0 .203.344h1.56c.05 0 .087.048.073.097l-1.074 3.691 4.511-4.793a.231.231 0 0 0-.169-.39H9.061a.075.075 0 0 1-.063-.117l.88-1.067c.372.21.995.474 1.788.453a3.42 3.42 0 0 0 1.597-.449c.122.057.826.374 1.582.056.768-.323 1.194-1.135 1.156-1.874-.05-.968-.898-1.83-2.027-1.929z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M1.068 11.253c0 .416.337.752.754.752s.754-.337.754-.752c0-.416-.754-1.505-.754-1.505s-.754 1.089-.754 1.505zm12.356 0c0 .416.337.752.754.752s.754-.337.754-.752c0-.416-.754-1.505-.754-1.505s-.754 1.089-.754 1.505zm-9.66 1.128c0 .416.337.752.754.752s.754-.337.754-.752-.754-1.505-.754-1.505-.754 1.089-.754 1.505zm6.965 0c0 .416.337.752.754.752s.754-.337.754-.752-.754-1.505-.754-1.505-.754 1.089-.754 1.505z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }